import { render, staticRenderFns } from "./about.vue?vue&type=template&id=3e81db8c&scoped=true&"
import script from "./about.vue?vue&type=script&lang=js&"
export * from "./about.vue?vue&type=script&lang=js&"
import style0 from "./about.vue?vue&type=style&index=0&id=3e81db8c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e81db8c",
  null
  
)

export default component.exports